import React from 'react';
import { Container, CustomSwitchInput, Label, SwitchContainer, SwitchContentContainer, SwitchIndicator, SwitchText } from './styles';

export default function SwitchInput({ name, label, text, defaultChecked, checked, onChange }) {
  return (
    <Container>
      <Label>{label}</Label>
      <SwitchContainer>
        <SwitchContentContainer>
          <CustomSwitchInput defaultChecked={defaultChecked} checked={checked} onChange={onChange} name={name} />
          <SwitchIndicator />
        </SwitchContentContainer>
        {text && <SwitchText>{text}</SwitchText>}
      </SwitchContainer>
    </Container>
  )
}